/**
 * Promotion dates for the limited-time offer
 * TODO: In the future, these could be fetched from the backend API
 */
const PROMOTION_START_DATE = '11/11/2025';
const PROMOTION_END_DATE = '12/07/2025';

/**
 * Apple trademarks disclaimer (used in all legal texts)
 */
const APPLE_TRADEMARKS_TEXT =
  'AirPods, Apple, Apple TV, Apple Watch, HomePod, iMac, iPad, iPad Pro, iPhone, MacBook and MacBook Pro are registered trademarks of Apple Inc. All rights reserved.';

/**
 * Legal Text Option A - 50% Bonus Points Disclaimer
 * Used for RPC codes that get the 1.5x points value ($0.0150 per point)
 */
export const LEGAL_TEXT_50 = `*Limited-Time Offer: From ${PROMOTION_START_DATE} – ${PROMOTION_END_DATE}, each point you redeem for Apple merchandise in the Apple® Shop in The Shops at Chase is worth $0.0150, which means that 100 points equals $1.50 in redemption value. If you choose to use points and your Chase credit card to pay for your purchase, your credit card will be charged the full remaining dollar amount. For example, if you choose to buy Apple merchandise at $120 at $1.50 redemption value and pay for half using points, you would use 4,000 points and your credit card would be billed $60. This Limited-Time Offer is for Chase Sapphire Reserve, J.P. Morgan Reserve and Chase Sapphire Reserve Business cardmembers. Promotional value does not apply to shipping/handling and applicable taxes.
<br><br>
${APPLE_TRADEMARKS_TEXT}`;

/**
 * Legal Text Option B - 25% Bonus Points Disclaimer
 * Used for RPC codes that get the 1.25x points value ($0.0125 per point)
 */
export const LEGAL_TEXT_25 = `*Limited-Time Offer: From ${PROMOTION_START_DATE} – ${PROMOTION_END_DATE}, each point you redeem for Apple merchandise in the Apple® Shop in The Shops at Chase is worth $0.0125, which means that 100 points equals $1.25 in redemption value. If you choose to use points and your Chase credit card to pay for your purchase, your credit card will be charged the full remaining dollar amount. For example, if you choose to buy Apple merchandise at $120 at $1.25 redemption value and pay for half using points, you would use 4,800 points and your credit card would be billed $60. This Limited-Time Offer is for Chase Sapphire Preferred, Chase Ink Business Preferred, Chase Ink Plus and Chase Ink Business Premier cardmembers. Promotional value does not apply to shipping/handling and applicable taxes.
<br><br>
${APPLE_TRADEMARKS_TEXT}`;

/**
 * Legal Text Option C - 10% Bonus Points Disclaimer
 * Used for RPC codes that get the 1.1x points value ($0.0110 per point)
 */
export const LEGAL_TEXT_10 = `*Limited-Time Offer: From ${PROMOTION_START_DATE} – ${PROMOTION_END_DATE}, each point you redeem for Apple merchandise in the Apple® Shop in The Shops at Chase is worth $0.0110, which means that 100 points equals $1.10 in redemption value. If you choose to use points and your Chase credit card to pay for your purchase, your credit card will be charged the full remaining dollar amount. For example, if you choose to buy Apple merchandise at $120 at $1.10 redemption value you would use 5,455 points and your credit card would be billed $60. This Limited-Time Offer is for Chase Sapphire, Chase Freedom, Chase Freedom Unlimited, Chase Freedom Student, Chase Freedom Flex, Chase Ink Cash, Chase Ink Business Cash and Chase Ink Business Unlimited cardmembers. Promotional value does not apply to shipping/handling and applicable taxes.
<br><br>
${APPLE_TRADEMARKS_TEXT}`;

/**
 * RPC codes that should display Legal Text 50% (1.5x value)
 */
const RPC_CODES_TEXT_50 = ['0544', '0545', '0550', '0552', '0511', '0518', '0519', '0512'];

/**
 * RPC codes that should display Legal Text 25% (1.25x value)
 */
const RPC_CODES_TEXT_25 = ['0444', '0551', '0477', '0514', '0515', '0484', '0486', '0535', '0536'];

/**
 * RPC codes that should display Legal Text 10% (1.1x value)
 */
const RPC_CODES_TEXT_10 = ['0516', '0419', '0475', '0309', '0540', '0404', '0534', '0509', '0533'];

/**
 * Internal map of RPC codes to their legal text
 */
const RPC_LEGAL_TEXT_MAP: Record<string, string> = {
  ...Object.fromEntries(RPC_CODES_TEXT_50.map((code) => [code, LEGAL_TEXT_50])),
  ...Object.fromEntries(RPC_CODES_TEXT_25.map((code) => [code, LEGAL_TEXT_25])),
  ...Object.fromEntries(RPC_CODES_TEXT_10.map((code) => [code, LEGAL_TEXT_10])),
};

/**
 * Get the legal text for a given RPC code
 * @param rpcCode - The RPC code from the user data
 * @returns The legal text string, or null if no text is defined for the code
 */
export function getLegalTextForRpcCode(rpcCode: string | undefined | null): string | null {
  if (!rpcCode) {
    return null;
  }

  return RPC_LEGAL_TEXT_MAP[rpcCode] ?? null;
}
